<div class="modal z-50 fixed w-screen h-full top-0 left-0 flex items-center justify-center p-5 lg:p-0">
  <div class="modal-overlay fixed w-full h-full bg-gray-900 opacity-50"></div>
  <div class="bg-white w-full lg:max-w-screen-lg mx-auto rounded-lg shadow-xl z-50 overflow-y-auto">
    <div class="flex flex-col gap-3 p-5 min-h-[250px]">
      <div class="flex justify-between items-center">
        <h1 class="text-lg font-bold leading-3">Editar relatório de atendimento</h1>

        <button
          type="button"
          class="btn-close"
          aria-label="Fechar formulário"
          routerLink="/dash/relatorios"
          appCloseOnEscape
        >
          <lucide-icon name="x" [size]="20"></lucide-icon>
        </button>
      </div>

      <form class="flex flex-col gap-5 flex-1" [formGroup]="formServiceInformation">
        <div class="w-full wrapper flex flex-col md:grid">
          <div class="form-group">
            <label class="block text-gray-700 text-sm font-bold mb-2"> Nº protocolo: </label>
            <input
              type="text"
              class="form-input appearance-none border rounded w-52 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              formControlName="protocol"
            />
          </div>

          <div class="flex gap-5 mt-3">
            <div class="form-group">
              <label class="block text-gray-700 text-sm font-bold mb-2"> Nº protocolo externo: </label>
              <input
                type="text"
                class="form-input appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                formControlName="externalProtocol"
              />
            </div>

            <div class="form-group">
              <label class="block text-gray-700 text-sm font-bold mb-2"> Status do atendimento: </label>
              <select
                class="form-input appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                formControlName="status"
              >
                <option value="concluido">Concluído em 1º nível</option>
                <option value="pendente operadora">Pendente | 2º nível operadora</option>
                <option value="pendente áreas internas">Pendente | 2º nível áreas internas</option>
              </select>
            </div>
          </div>

          <div class="form-group">
            <label class="block text-gray-700 text-sm font-bold mb-2 mt-6"> Observação sobre o atendimento: </label>
            <textarea
              class="appearance-none border rounded w-full py-6 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              formControlName="observation"
              rows="4"
            ></textarea>
          </div>
        </div>

        <div class="form-group flex justify-end items-end">
          <button
            *isAllowed="[ERoleAdminString.Admin, 'reports.edit']"
            alt="Salvar relatório"
            (click)="editAttendanceReports()"
            class="w-80 h-9 btn btn--secondary"
          >
            + Salvar relatório
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
